import { createAction } from "typesafe-actions";
export var modify_show_points_info = createAction("feedbackDisplayed/MODIFY_SHOW_POINTS_INFO", function (resolve) {
  return function (newValue) {
    return resolve(newValue);
  };
});